<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">

  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">จัดการค่าธรรมเนียม</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">ตั้งค่าและจัดการรายการค่าธรรมเนียม</p>
    </div>
    <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
      <button type="button" (click)="onRefresh()"
        class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 transition-all flex items-center justify-center h-[46px]">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" type="button" (click)="openCreate()"
        class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg flex items-center justify-center gap-2 h-[46px]">
        <span class="material-icons text-xl">add_circle</span>
        เพิ่มค่าธรรมเนียม
      </button>
    </div>
  </div>

  <div class="bg-white dark:bg-slate-800 rounded-3xl shadow border border-slate-100 dark:border-slate-700 overflow-hidden relative">
    <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

    <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-wrap items-center justify-between gap-3">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">payments</span>
        รายการค่าธรรมเนียม
      </h3>
      <div class="flex gap-2 items-center w-full sm:w-auto">
        <input type="text" [ngModel]="searchText()" (ngModelChange)="searchText.set($event)"
          (keyup.enter)="onSearch()" placeholder="ค้นหาชื่อ..."
          class="flex-1 sm:w-64 px-4 py-2 rounded-xl border bg-slate-50 dark:bg-slate-900 dark:border-slate-700 text-sm">
        <button type="button" (click)="onSearch()"
          class="px-4 py-2 rounded-xl bg-slate-100 dark:bg-slate-700 text-sm font-bold">ค้นหา</button>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[280px]">
      <table class="w-full text-left text-sm">
        <thead class="bg-slate-50 dark:bg-slate-800/50 text-xs uppercase text-slate-400">
          <tr>
            <th class="px-6 py-4">ID</th>
            <th class="px-6 py-4">ชื่อ</th>
            <th class="px-6 py-4 text-right">Fee</th>
            <th class="px-6 py-4">VAT</th>
            <th class="px-6 py-4">Fee Group</th>
            <th class="px-6 py-4">อัปเดต</th>
            <th class="px-6 py-4 text-center">จัดการ</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of feeItems()" class="border-t border-slate-100 dark:border-slate-800 hover:bg-slate-50/50 dark:hover:bg-slate-800/30">
            <td class="px-6 py-4 text-slate-400">{{ item.id }}</td>
            <td class="px-6 py-4 font-semibold">{{ item.name }}</td>
            <td class="px-6 py-4 text-right">{{ item.fee | number:'1.2-2' }}</td>
            <td class="px-6 py-4">{{ item.vat ? 'ใช่' : 'ไม่' }}</td>
            <td class="px-6 py-4">{{ item.feeGroupId || '-' }}</td>
            <td class="px-6 py-4 text-xs text-slate-400">{{ formatDate(item.writeDate) }}</td>
            <td class="px-6 py-4 text-center">
              <button *ngIf="canUpdate" type="button" (click)="openEditFee(item)"
                class="p-2 rounded-lg hover:bg-amber-50 dark:hover:bg-amber-900/20 text-amber-600">
                <span class="material-icons text-[18px]">edit</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="!isLoading() && feeItems().length === 0">
            <td colspan="7" class="px-6 py-16 text-center text-slate-400">ไม่พบข้อมูล</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="p-4 border-t border-slate-100 dark:border-slate-700 flex flex-wrap items-center justify-between gap-3">
      <div class="text-xs text-slate-400">ทั้งหมด {{ totalItems() }} รายการ</div>
      <div class="flex gap-2">
        <button *ngFor="let p of pagesArray" type="button" (click)="setPage(p)"
          class="w-8 h-8 rounded-lg text-xs font-bold"
          [ngClass]="p === currentPage() ? 'bg-amber-400 text-white' : 'bg-slate-100 dark:bg-slate-800'">{{ p }}</button>
      </div>
    </div>
  </div>
</div>

<app-modal-parking-fee *ngIf="isFeeModalOpen()" [editRow]="selectedFee()"
  (close)="closeFeeModal()" (saveSuccess)="onFeeSaved()"></app-modal-parking-fee>
